import React from 'react';

const ActiveNavComp = () => {
  return (
    <>
        <div className='text-4xl font-syne'>
            X
        </div>
    </>
  );
};

export default ActiveNavComp;
